



















































export default {
  name: "CondFormatEditor",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    whenOptions: {
      type: Array,
      default() {
        return [
          { value: "below_min", text: this.$t("COND_FORMAT_WHEN_BELOW_MIN") },
          { value: "above_max", text: this.$t("COND_FORMAT_WHEN_ABOVE_MAX") },
        ];
      },
    },
    /** Initial expand state. Default true if there are rules. */
    initiallyExpanded: {
      type: Boolean,
      default: null,
    },
  },
  data() {
    return {
      rules: [],
      expanded: false,
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        // Sync working copy when parent updates `value`. Skip when the incoming
        // value is structurally identical to the current working copy — this
        // avoids the v-model ping-pong (parent → value → rules → emit → parent
        // → value …) that would otherwise lock the browser in a tight loop.
        const incomingJson = JSON.stringify(Array.isArray(newVal) ? newVal : []);
        const currentJson = JSON.stringify(this.rules || []);
        if (incomingJson === currentJson) return;
        this._syncingFromValue = true;
        this.rules = JSON.parse(incomingJson);
        if (this.initiallyExpanded === null) {
          this.expanded = this.rules.length > 0;
        } else {
          this.expanded = this.initiallyExpanded;
        }
        this.$nextTick(() => {
          this._syncingFromValue = false;
        });
      },
    },
    rules: {
      deep: true,
      handler(newVal) {
        // Skip emit when the change came from the value watcher above —
        // otherwise the parent would re-set value, retriggering this watcher.
        if (this._syncingFromValue) return;
        // Also skip if the new rules equal the current value structurally
        // (defensive: covers cases where the parent re-emits the same payload).
        const newJson = JSON.stringify(newVal || []);
        const valueJson = JSON.stringify(Array.isArray(this.value) ? this.value : []);
        if (newJson === valueJson) return;
        this.$emit("input", JSON.parse(newJson));
      },
    },
  },
  methods: {
    addRule() {
      this.rules.push({
        uid: "cf_" + Date.now() + "_" + Math.floor(Math.random() * 10000),
        when: { type: "below_min" },
        textColor: "",
        bold: false,
        italic: false,
        underline: false,
      });
    },
    removeRule(idx) {
      this.rules.splice(idx, 1);
    },
  },
};
